import { curry } from "ramda";
import { SpreadAccountRow, SpreadUnmappedAccount } from "../spread/types";

export interface SpreadUnmappedAccountsByPage {
  [page: string]: SpreadUnmappedAccount[];
}

export const getUnmappedAccountsByPage = curry(
  (
    unmappedAccountsByPage: SpreadUnmappedAccountsByPage,
    pageNumber: number
  ): SpreadUnmappedAccount[] =>
    unmappedAccountsByPage[pageNumber.toString()] || []
);

export interface SpreadMappedAccountsByPage {
  [page: string]: SpreadAccountRow[];
}

export const getMappedAccountsByPage = curry(
  (
    mappedAccountsByPage: SpreadMappedAccountsByPage,
    pageNumber: number
  ): SpreadAccountRow[] => mappedAccountsByPage[pageNumber.toString()] || []
);



// WEBPACK FOOTER //
// ./src/spread/model/mappedUnmappedAccounts/mappedUnmappedAccountsByPage.ts